import {
	addCategoryApi,
	getCategoryListApi,
	getBrandListApi,
	addBrandApi,
	addOrUpdateProductApi,
	filterProductsByCategoryIdsApi,
	getAllStoreProducts,
	getSearchStoreProductsApi,
} from '../../services/bToC/storeProducts';
import { getErrorObject } from '../../utilities/utils';
import { IGetBrandListModel, IAddOrUpdateProductModel } from '../../models/storeProducts';
import { showMsgFromJson } from '../common';
import Constants from '../../utilities/appConstants';

export const types = {
	// Add Category
	RETAILER_ADD_CATEGORY_REQUEST: 'retailer/RETAILER_ADD_CATEGORY_REQUEST',
	RETAILER_ADD_CATEGORY_FAILURE: 'retailer/RETAILER_ADD_CATEGORY_FAILURE',
	RETAILER_ADD_CATEGORY_SUCCESS: 'retailer/RETAILER_ADD_CATEGORY_SUCCESS',
	// Get Category
	RETAILER_GET_CATEGORY_REQUEST: 'retailer/RETAILER_GET_CATEGORY_REQUEST',
	RETAILER_GET_CATEGORY_FAILURE: 'retailer/RETAILER_GET_CATEGORY_FAILURE',
	RETAILER_GET_CATEGORY_SUCCESS: 'retailer/RETAILER_GET_CATEGORY_SUCCESS',
	// Add Brand
	RETAILER_ADD_BRAND_REQUEST: 'retailer/RETAILER_ADD_BRAND_REQUEST',
	RETAILER_ADD_BRAND_FAILURE: 'retailer/RETAILER_ADD_BRAND_FAILURE',
	RETAILER_ADD_BRAND_SUCCESS: 'retailer/RETAILER_ADD_BRAND_SUCCESS',
	// Get Brand
	RETAILER_GET_BRAND_REQUEST: 'retailer/RETAILER_GET_BRAND_REQUEST',
	RETAILER_GET_BRAND_FAILURE: 'retailer/RETAILER_GET_BRAND_FAILURE',
	RETAILER_GET_BRAND_SUCCESS: 'retailer/RETAILER_GET_BRAND_SUCCESS',
	// Add Product
	RETAILER_ADD_UPDATE_PRODUCT_REQUEST: 'retailer/RETAILER_ADD_UPDATE_PRODUCT_REQUEST',
	RETAILER_ADD_UPDATE_PRODUCT_FAILURE: 'retailer/RETAILER_ADD_UPDATE_PRODUCT_FAILURE',
	RETAILER_ADD_UPDATE_PRODUCT_SUCCESS: 'retailer/RETAILER_ADD_UPDATE_PRODUCT_SUCCESS',
	// Filter Product
	RETAILER_GET_PRODUCT_REQUEST: 'retailer/RETAILER_GET_PRODUCT_REQUEST',
	RETAILER_GET_PRODUCT_FAILURE: 'retailer/RETAILER_GET_PRODUCT_FAILURE',
	RETAILER_GET_PRODUCT_SUCCESS: 'retailer/RETAILER_GET_PRODUCT_SUCCESS',
};

const initialState = {
	isCategoryListLoading: false,
	error: null,
	categoryList: [],
	categoryCount: 0,
	isBrandListLoading: false,
	brandList: [],
	brandCount: 0,
	isProductListLoading: false,
	productList: [],
	productCount: 0,
};

export const storeProducts = (state = initialState, action) => {
	switch (action.type) {
		case types.RETAILER_ADD_CATEGORY_REQUEST:
		case types.RETAILER_ADD_CATEGORY_FAILURE:
		case types.RETAILER_ADD_CATEGORY_SUCCESS:
			return addCategoryReducer(state, action);
		case types.RETAILER_GET_CATEGORY_REQUEST:
		case types.RETAILER_GET_CATEGORY_FAILURE:
		case types.RETAILER_GET_CATEGORY_SUCCESS:
			return getCategoryReducer(state, action);
		case types.RETAILER_ADD_BRAND_REQUEST:
		case types.RETAILER_ADD_BRAND_FAILURE:
		case types.RETAILER_ADD_BRAND_SUCCESS:
			return addBrandReducer(state, action);
		case types.RETAILER_GET_BRAND_REQUEST:
		case types.RETAILER_GET_BRAND_FAILURE:
		case types.RETAILER_GET_BRAND_SUCCESS:
			return getBrandReducer(state, action);
		case types.RETAILER_ADD_UPDATE_PRODUCT_REQUEST:
		case types.RETAILER_ADD_UPDATE_PRODUCT_FAILURE:
		case types.RETAILER_ADD_UPDATE_PRODUCT_SUCCESS:
			return addOrUpdateProductReducer(state, action);
		case types.RETAILER_GET_PRODUCT_REQUEST:
		case types.RETAILER_GET_PRODUCT_FAILURE:
		case types.RETAILER_GET_PRODUCT_SUCCESS:
			return getProductReducer(state, action);
		default:
			return state;
	}
};

const getCategoryReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_GET_CATEGORY_REQUEST:
			return { ...state, isCategoryListLoading: true };
		case types.RETAILER_GET_CATEGORY_SUCCESS:
			return {
				...state,
				isCategoryListLoading: false,
				error: null,
				categoryList: [...action.payload],
				categoryCount: Number(action.payload.length),
			};
		case types.RETAILER_GET_CATEGORY_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isCategoryListLoading: false,
			};
		default:
			return state;
	}
};

const getBrandReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_GET_BRAND_REQUEST:
			return { ...state, isBrandListLoading: true };
		case types.RETAILER_GET_BRAND_SUCCESS:
			return {
				...state,
				isBrandListLoading: false,
				error: null,
				brandList: [...action.payload],
				brandCount: Number(action.payload.length),
			};
		case types.RETAILER_GET_BRAND_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isBrandListLoading: false,
				brandList: [],
				brandCount: Number(0),
			};
		default:
			return state;
	}
};

const addCategoryReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_ADD_CATEGORY_REQUEST:
			return { ...state, isCategoryListLoading: true };
		case types.RETAILER_ADD_CATEGORY_SUCCESS:
			return {
				...state,
				isCategoryListLoading: false,
				error: null,
				categoryList: [...action.payload],
				categoryCount: Number(action.payload.length),
			};
		case types.RETAILER_ADD_CATEGORY_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isCategoryListLoading: false,
			};
		default:
			return state;
	}
};

const addBrandReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_ADD_BRAND_REQUEST:
			return { ...state, isBrandListLoading: true };
		case types.RETAILER_ADD_BRAND_SUCCESS:
			return {
				...state,
				isBrandListLoading: false,
				error: null,
				brandList: [...action.payload],
				brandCount: Number(action.payload.length),
			};
		case types.RETAILER_ADD_BRAND_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isBrandListLoading: false,
			};
		default:
			return state;
	}
};

const addOrUpdateProductReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_ADD_UPDATE_PRODUCT_REQUEST:
			return { ...state, isProductListLoading: true };
		case types.RETAILER_ADD_UPDATE_PRODUCT_SUCCESS:
			if (action.variant === 'delete') {
				return {
					...state,
					productList: state.productList.filter(
						(product) => Number(product.ProductId) !== Number(action.payload[0].Id)
					),
					productCount: Number(state.productCount - 1),
					isProductListLoading: false,
					error: null,
				};
			} else if (action.variant === 'update') {
				return {
					...state,
					isProductListLoading: false,
					error: null,
				};
			}
			return {
				...state,
				isProductListLoading: false,
				error: null,
			};
		case types.RETAILER_ADD_UPDATE_PRODUCT_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isProductListLoading: false,
			};
		default:
			return state;
	}
};

const getProductReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_GET_PRODUCT_REQUEST:
			return { ...state, isProductListLoading: true };
		case types.RETAILER_GET_PRODUCT_SUCCESS:
			return {
				...state,
				isProductListLoading: false,
				error: null,
				productList: [...action.payload],
				productCount: Number(action.payload.length),
			};
		case types.RETAILER_GET_PRODUCT_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isProductListLoading: false,
				productList: [],
				productCount: 0,
			};
		default:
			return state;
	}
};

export const getCategoryList = () => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_GET_CATEGORY_REQUEST });
		try {
			const response = await getCategoryListApi();
			const payload = response.data.Data;
			dispatch({ type: types.RETAILER_GET_CATEGORY_SUCCESS, payload });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_GET_CATEGORY_FAILURE));
		}
	};
};

export const getBrandList = (data: IGetBrandListModel) => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_GET_BRAND_REQUEST });
		try {
			const response = await getBrandListApi(data);
			const payload = response.data.Data;

			dispatch({ type: types.RETAILER_GET_BRAND_SUCCESS, payload });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_GET_BRAND_FAILURE));
		}
	};
};

export const addCategory = (data: IAddCategoryModel) => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_ADD_CATEGORY_REQUEST });
		try {
			await addCategoryApi(data);

			const response = await getCategoryListApi();
			const payload = response.data.Data;

			dispatch(showMsgFromJson(`store.products.successMessages.categoryCreated`, Constants.SUCCESS));

			dispatch({ type: types.RETAILER_ADD_CATEGORY_SUCCESS, payload: payload });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_ADD_CATEGORY_FAILURE));
		}
	};
};

export const addBrand = (data: IAddBrandModel) => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_ADD_BRAND_REQUEST });
		try {
			const addBrandResponse = await addBrandApi(data);
			const addBrandPayload = addBrandResponse.data.Data;

			const response = await getBrandListApi({ Ids: [Number(addBrandPayload.ParentId)] });
			const payload = response.data.Data;

			dispatch(showMsgFromJson(`store.products.successMessages.brandCreated`, Constants.SUCCESS));

			dispatch({ type: types.RETAILER_ADD_BRAND_SUCCESS, payload: payload });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_ADD_BRAND_FAILURE));
		}
	};
};

export const addOrUpdateProduct = (data: IAddOrUpdateProductModel) => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_ADD_UPDATE_PRODUCT_REQUEST });
		try {
			if (data[0]['Action'] === Constants.BToC_PRODUCT_ACTION_CREATE) {
				await addOrUpdateProductApi(data);
				dispatch(showMsgFromJson(`store.products.successMessages.productCreated`, Constants.SUCCESS));

				dispatch({ type: types.RETAILER_ADD_UPDATE_PRODUCT_SUCCESS, variant: 'add' });
			}
			if (data[0]['Action'] === Constants.BToC_PRODUCT_ACTION_DELETE) {
				await addOrUpdateProductApi(data);

				dispatch(showMsgFromJson(`store.products.successMessages.productDeleted`, Constants.SUCCESS));

				dispatch({ type: types.RETAILER_ADD_UPDATE_PRODUCT_SUCCESS, payload: data, variant: 'delete' });
			}
			if (data[0]['Action'] === Constants.BToC_PRODUCT_ACTION_UPDATE) {
				await addOrUpdateProductApi(data);

				dispatch(showMsgFromJson(`store.products.successMessages.productUpdated`, Constants.SUCCESS));

				dispatch({ type: types.RETAILER_ADD_UPDATE_PRODUCT_SUCCESS, variant: 'update' });
			}
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_ADD_UPDATE_PRODUCT_FAILURE));
		}
	};
};

export const getProduct = (type: string, data) => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_GET_PRODUCT_REQUEST });
		try {
			if (type === 'FilterByCategoryIds') {
				const response = await filterProductsByCategoryIdsApi(data);
				const payload = response.data.Data;

				dispatch({ type: types.RETAILER_GET_PRODUCT_SUCCESS, payload });
			} else if (type === 'All') {
				const response = await getAllStoreProducts(data);
				const payload = response.data.Data;

				dispatch({ type: types.RETAILER_GET_PRODUCT_SUCCESS, payload });
			} else if (type === 'Search') {
				const response = await getSearchStoreProductsApi(data);
				const payload = response.data.Data;

				dispatch({ type: types.RETAILER_GET_PRODUCT_SUCCESS, payload });
			}
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_GET_PRODUCT_FAILURE));
		}
	};
};

const promiseCatchBlock = (error: any, type: string) => {
	return (dispatch) => {
		const { message } = getErrorObject(error);
		dispatch({
			type: type,
			payload: { error: message },
		});
	};
};
